import { useEffect, useState } from 'react';

export function useVisualViewportHeight() {
    const [height, setHeight] = useState(
        () => window.visualViewport?.height ?? window.innerHeight
    );

    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return;
        const onChange = () => setHeight(vv.height);
        vv.addEventListener('resize', onChange);
        vv.addEventListener('scroll', onChange);
        onChange();
        return () => {
            vv.removeEventListener('resize', onChange);
            vv.removeEventListener('scroll', onChange);
        };
    }, []);

    return height;
}
